declare global {
  var dtrum: {
    identifyUser: (name: string) => void;
    reportError: (error: Error | string) => void;
    enterAction?: (actionName: string, actionType?: string, startTime?: number, parentActionId?: number) => number;
    leaveAction?: (actionId: number, stopTime?: number, parentActionId?: number) => void;
    getCurrentActionId?: () => number | undefined;
    addActionProperties?: (
      actionId?: number,
      longProperties?: Record<string, number>,
      doubleProperties?: Record<string, number>,
      stringProperties?: Record<string, string>
    ) => void;
  } | undefined;
  var dynatraceUserTag: string | undefined;
}

export function observerCallback(observer: MutationObserver): void {
  try {
    const header = document.querySelector('tds-global-header');
    if (!header) return;

    const navItem = header.querySelector('span[slot="actions"]');
    if (!navItem) return;

    const userName = (navItem.textContent ?? '').replace('Welcome,', '').trim();

    if (userName && globalThis.dtrum) {
      globalThis.dtrum.identifyUser(userName);
      globalThis.dynatraceUserTag = userName;
      observer.disconnect();
    }
  } catch (e) {
    console.error('Dynatrace user tagging failed:', e);
    observer.disconnect();
  }
}

export function setupDynatraceUserTagging(): MutationObserver {
  const observer = new MutationObserver(() => observerCallback(observer));
  observer.observe(document.body, { childList: true, subtree: true });
  return observer;
}
